import {
  HRCV_FREE_DATA,
  HRCV_SET_CV_LOADING_STATE,
  HRCV_SET_CURRENT_CV,
  HRCV_GET_CV_STATUS_LIST,
  HRCV_GET_CV_TYPES_LIST,
  HRCV_SET_CV_FILTER,
  HRCV_CLEAR_CV_LIST,
  HRCV_GET_CV_LIST, // Получение списка аттестаций,
  HRCV_POST_CV,
  HRCV_SET_CURRENT_Q,
  HRCV_GET_QUESTIONS,
  HRCV_ADD_QUESTION,
  HRCV_UPD_QUESTION,
  HRCV_DEL_QUESTION,
  HRCV_SET_CURRENT_A,
  HRCV_ADD_ANSWER,
  HRCV_UPD_ANSWER,
  HRCV_DEL_ANSWER,
  HRCV_GET_ANSWERS,
  HRCV_GET_VACANCY_LIST,
  HRCV_CLEAR_VACANCY_LIST,
  HRCV_SET_VACANCY_LOADING_STATE,
  HRCV_GET_VACANCY_STATES,
  HRCV_SET_VACANCY_FILTER,
  HRCV_ADD_VACANCY,
  HRCV_UPD_VACANCY,
  HRCV_POST_VACANCY,
  HRCV_SET_CURRENT_VACANCY
} from '../actions/hrcv'
import { UI_REQUEST, UI_SUCCESS, UI_ERROR } from '../actions/ui'
import axios from 'axios'
const state = {
  currentCV: {},
  currentQuestion: {},
  currentAnswer: {},
  CVList: [],
  vacancyList: [],
  CVStatesList: [],
  vacStatesList: [],
  CVTypesList: [],
  CVQuestionsList: [],
  cvListLoading: false,
  vacListLoading: false,
  currentVacancy: {},
  currentCVFilter: null,
  currentVacancyFilter: null
}

const getters = {
  getCurrentCVState: state => state.currentCV.DS_ID,
  getCurrentCVID: state => state.currentTest.DOC_ID,
  getCurrentCV: state => state.currentCV,
  getCVTypeQuestions: state => state.CVQuestionsList,
  getCurrentCVQuestion: state => state.currentQuestion,
  getCurrentCVAnswer: state => state.currentAnswer,
  getCurrentCVAvailStates: state => {
    if (typeof state.currentCV.AVAIL_STATUS !== 'undefined') {
      return state.currentCV.AVAIL_STATUS
    } else {
      return []
    }
  },
  getCurrentCVAvailReports: state => state.currentCV.AVAIL_REPORTS ? state.currentCV.AVAIL_REPORTS : [],
  getCurrentCVList: state => state.CVList,
  getCurrentVacancyList: state => state.vacancyList,
  getCVStatesList: state => state.CVStatesList,
  getVacancyStatesList: state => state.vacStatesList,
  getCurrentVacancyAvailStates: state => {
    if (typeof state.currentVacancy.AVAIL_STATUS !== 'undefined') {
      return state.currentVacancy.AVAIL_STATUS
    } else {
      return []
    }
  },
  getCVTypesList: state => state.CVTypesList,
  getCVListLoading: state => state.cvListLoading,
  getCurrentCVFilter: state => {
    var cf = state.currentCVFilter
    return cf
  },
  getCurrentVacancyFilter: state => {
    var vf = state.currentVacancyFilter
    return vf
  },
  getCurrentVacancy: state => state.currentVacancy,
  getCurrentVacancyRoute: state => state.currentVacancy.ROUTE

}

const actions = {
  [HRCV_FREE_DATA]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      commit(HRCV_FREE_DATA)
      resolve('success')
    }),
  [HRCV_GET_CV_STATUS_LIST]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'HRCV_GET_CV_STATUS_LIST', topic: 'Загрузка списка статусов анкет', error: null })
      commit(HRCV_SET_CV_LOADING_STATE, true)
      axios({ url: '/api/anketa/getCVStatusList.php', method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(HRCV_GET_CV_STATUS_LIST, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'HRCV_GET_CV_STATUS_LIST' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'HRCV_GET_CV_STATUS_LIST', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'HRCV_GET_CV_STATUS_LIST', result: 'Получение списка возможных статусов анкет: ошибка сервера' })
          reject(new Error(err))
        })
        .finally(() => {
          commit(HRCV_SET_CV_LOADING_STATE, false)
        })
    }),
  [HRCV_GET_VACANCY_STATES]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'HRCV_GET_VACANCY_STATES', topic: 'Загрузка списка статусов вакансий', error: null })
      commit(HRCV_SET_VACANCY_LOADING_STATE, true)
      axios({ url: '/api/anketa/getVacancyStatesList.php', method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(HRCV_GET_VACANCY_STATES, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'HRCV_GET_VACANCY_STATES' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'HRCV_GET_VACANCY_STATES', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'HRCV_GET_VACANCY_STATES', result: 'Получение списка возможных статусов вакансий: ошибка сервера' })
          reject(new Error(err))
        })
        .finally(() => {
          commit(HRCV_SET_VACANCY_LOADING_STATE, false)
        })
    }),
  [HRCV_GET_CV_TYPES_LIST]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'HRCV_GET_CV_TYPES_LIST', topic: 'Загрузка списка типов анкет', error: null })
      commit(HRCV_SET_CV_LOADING_STATE, true)
      axios({ url: '/api/anketa/getCVTypesList.php', method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(HRCV_GET_CV_TYPES_LIST, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'HRCV_GET_CV_TYPES_LIST' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'HRCV_GET_CV_TYPES_LIST', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'HRCV_GET_CV_TYPES_LIST', result: 'Получение списка типов анкет: ошибка сервера' })
          reject(new Error(err))
        })
        .finally(() => {
          commit(HRCV_SET_CV_LOADING_STATE, false)
        })
    }),

  [HRCV_GET_CV_LIST]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'HRCV_GET_CV_LIST', topic: 'Загрузка списка запросов', error: null })
      console.log('Called action HRCV_GET_CV_LIST, current filter is  ', state.currentCVFilter)
      commit(HRCV_CLEAR_CV_LIST)
      var filterSet = !(state.currentCVFilter === null)
      if (filterSet) {
        var reqData = {
          DS_ID: state.currentCVFilter
        }
      } else {
        reject(new Error('Не установлен фильтр состояний'))
        dispatch(UI_ERROR, { action: 'HRCV_GET_CV_LIST', result: 'Не установлен фильтр состояний' })
        return
      }
      commit(HRCV_SET_CV_LOADING_STATE, true)
      axios({ url: '/api/anketa/getCVList.php', data: reqData, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(HRCV_GET_CV_LIST, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'HRCV_GET_CV_LIST' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'HRCV_GET_CV_LIST', result: 'Ошибка получения списка анкет: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'HRCV_GET_CV_LIST', result: 'Получение списка анкет: ошибка сервера' })
          reject(new Error(err))
        })
        .finally(() => {
          commit(HRCV_SET_CV_LOADING_STATE, false)
        })
    }),

  [HRCV_GET_VACANCY_LIST]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'HRCV_GET_VACANCY_LIST', topic: 'Загрузка списка вакансий', error: null })
      console.log('Called action HRCV_GET_VACANCY_LIST, current filter is  ', state.currentVacancyFilter)
      commit(HRCV_CLEAR_VACANCY_LIST)
      var filterSet = !(state.currentVacancyFilter === null)
      if (filterSet) {
        var reqData = {
          DS_ID: state.currentVacancyFilter
        }
      } else {
        reject(new Error('Не установлен фильтр состояний'))
        dispatch(UI_ERROR, { action: 'HRCV_GET_VACANCY_LIST', result: 'Не установлен фильтр состояний' })
        return
      }
      commit(HRCV_SET_VACANCY_LOADING_STATE, true)
      axios({ url: '/api/anketa/getVacancyList.php', data: reqData, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(HRCV_GET_VACANCY_LIST, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'HRCV_GET_VACANCY_LIST' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'HRCV_GET_VACANCY_LIST', result: 'Ошибка получения списка вакансий: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'HRCV_GET_VACANCY_LIST', result: 'Получение списка вакансий: ошибка сервера' })
          reject(new Error(err))
        })
        .finally(() => {
          commit(HRCV_SET_VACANCY_LOADING_STATE, false)
        })
    }),
  [HRCV_SET_CV_FILTER]: ({ commit, dispatch }, filterItem) =>
    new Promise((resolve, reject) => {
      console.log('Called action HRCV_SET_CV_FILTER] ', filterItem)
      dispatch(UI_REQUEST, { action: 'HRCV_SET_CV_FILTER', topic: 'Установка фильтра анкет', error: null })
      if (filterItem !== state.currentCVFilter) {
        commit(HRCV_SET_CV_FILTER, filterItem)
        commit(HRCV_CLEAR_CV_LIST)
        dispatch(HRCV_GET_CV_LIST)
          .then(resp => {
            dispatch(UI_SUCCESS, { action: 'HRCV_SET_CV_FILTER' })
            resolve()
          })
          .catch((err) => {
            dispatch(UI_ERROR, { action: 'HRCV_SET_CV_FILTER', result: 'Установка фильтра анкет: ошибка сервера' })
            reject(err)
          })
      } else {
        dispatch(UI_SUCCESS, { action: 'HRCV_SET_CV_FILTER' })
        resolve()
      }
    }),
  [HRCV_SET_VACANCY_FILTER]: ({ commit, dispatch }, filterItem) =>
    new Promise((resolve, reject) => {
      console.log('Called action HRCV_SET_VACANCY_FILTER] ', filterItem)
      dispatch(UI_REQUEST, { action: 'HRCV_SET_VACANCY_FILTER', topic: 'Установка фильтра вакансий', error: null })
      if (filterItem !== state.currentCVFilter) {
        commit(HRCV_SET_VACANCY_FILTER, filterItem)
        commit(HRCV_CLEAR_VACANCY_LIST)
        dispatch(HRCV_GET_VACANCY_LIST)
          .then(resp => {
            dispatch(UI_SUCCESS, { action: 'HRCV_SET_VACANCY_FILTER' })
            resolve()
          })
          .catch((err) => {
            dispatch(UI_ERROR, { action: 'HRCV_SET_VACANCY_FILTER', result: 'Установка фильтра вакансий: ошибка сервера' })
            reject(err)
          })
      } else {
        dispatch(UI_SUCCESS, { action: 'HRCV_SET_VACANCY_FILTER' })
        resolve()
      }
    }),
  [HRCV_SET_CURRENT_CV]: ({ commit, dispatch }, requestItem) =>
    new Promise((resolve, reject) => {
      console.log('Called action HRCV_SET_CURRENT_CV ', requestItem)
      dispatch(UI_REQUEST, { action: 'HRCV_SET_CURRENT_CV', topic: 'Установка активного запроса', error: null })
      if (requestItem.DOC_ID !== state.currentCV.DOC_ID) {
        console.log('Setting new current request', requestItem)
        commit(HRCV_SET_CURRENT_CV, requestItem)
      }
      dispatch(UI_SUCCESS, { action: 'HRCV_SET_CURRENT_CV' })
      resolve()
    }),

  [HRCV_SET_CURRENT_VACANCY]: ({ commit, dispatch }, requestItem) =>
    new Promise((resolve, reject) => {
      console.log('Called action HRCV_SET_CURRENT_VACANCY ', requestItem)
      dispatch(UI_REQUEST, { action: 'HRCV_SET_CURRENT_VACANCY', topic: 'Установка активной вакансии', error: null })
      if (requestItem.VAC_ID !== state.currentVacancy.VAC_ID) {
        console.log('Setting new current vacancy', requestItem)
        commit(HRCV_SET_CURRENT_VACANCY, requestItem)
      }
      dispatch(UI_SUCCESS, { action: 'HRCV_SET_CURRENT_VACANCY' })
      resolve()
    }),

  [HRCV_SET_CURRENT_Q]: ({ commit, dispatch }, requestItem) =>
    new Promise((resolve, reject) => {
      console.log('Called action HRCV_SET_CURRENT_Q ', requestItem)
      dispatch(UI_REQUEST, { action: 'HRCV_SET_CURRENT_Q', topic: 'Установка активного вопроса', error: null })
      if (requestItem.QID !== state.currentQuestion.QID) {
        console.log('Setting new current question', requestItem)
        commit(HRCV_SET_CURRENT_Q, requestItem)
      }
      dispatch(UI_SUCCESS, { action: 'HRCV_SET_CURRENT_Q' })
      resolve()
    }),

  [HRCV_SET_CURRENT_A]: ({ commit, dispatch }, requestItem) =>
    new Promise((resolve, reject) => {
      console.log('Called action HRCV_SET_CURRENT_A ', requestItem)
      dispatch(UI_REQUEST, { action: 'HRCV_SET_CURRENT_A', topic: 'Установка активного ответа', error: null })
      if (requestItem.ANS_ID !== state.currentAnswer.ANS_ID) {
        console.log('Setting new current answer', requestItem)
        commit(HRCV_SET_CURRENT_A, requestItem)
      }
      dispatch(UI_SUCCESS, { action: 'HRCV_SET_CURRENT_A' })
      resolve()
    }),

  [HRCV_GET_QUESTIONS]: ({ commit, dispatch }, answers) =>
    new Promise((resolve, reject) => {
      console.log('Called action HRCV_GET_QUESTIONS ', answers)
      dispatch(UI_REQUEST, { action: 'HRCV_GET_QUESTIONS', topic: 'Получение списка вопросов для типа анкеты', error: null })
      axios({ url: '/api/anketa/getCVQuestions.php', data: answers, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(HRCV_GET_QUESTIONS, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'HRCV_GET_QUESTIONS' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'HRCV_GET_QUESTIONS', result: 'списка вопросов для типа анкеты: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'HRCV_GET_QUESTIONS', result: 'списка вопросов для типа анкеты: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [HRCV_GET_ANSWERS]: ({ commit, dispatch }, answers) =>
    new Promise((resolve, reject) => {
      console.log('Called action HRCV_GET_ANSWERS ', answers)
      dispatch(UI_REQUEST, { action: 'HRCV_GET_ANSWERS', topic: 'Установка ответов на текущий вопрос', error: null })
      axios({ url: '/api/anketa/getUserAnswers.php', data: answers, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(HRCV_GET_ANSWERS, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'HRCV_GET_ANSWERS' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'HRCV_GET_ANSWERS', result: 'Установка ответов на текущий вопрос: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'HRCV_GET_ANSWERS', result: 'Установка ответов на текущий вопрос: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [HRCV_ADD_QUESTION]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'HRCV_ADD_QUESTION', topic: 'Создание вопроса', error: null })
      axios({ url: '/api/anketa/addCVQuestion.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(HRCV_ADD_QUESTION, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'HRCV_ADD_QUESTION' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'HRCV_ADD_QUESTION', result: 'Создание вопроса: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'HRCV_ADD_QUESTION', result: 'Создание вопроса: ошибка сервера' })
          reject(new Error(err))
        })
    }),
  [HRCV_UPD_QUESTION]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'HRCV_UPD_QUESTION', topic: 'Обновление вопроса', error: null })
      axios({ url: '/api/anketa/addCVQuestion.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(HRCV_UPD_QUESTION, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'HRCV_UPD_QUESTION' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'HRCV_UPD_QUESTION', result: 'Обновление вопроса: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'HRCV_UPD_QUESTION', result: 'Обновление вопроса: ошибка сервера' })
          reject(new Error(err))
        })
    }),
  [HRCV_DEL_QUESTION]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'HRCV_DEL_QUESTION', topic: 'Обновление вопроса', error: null })
      axios({ url: '/api/anketa/delQuestion.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(HRCV_DEL_QUESTION, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'HRCV_DEL_QUESTION' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'HRCV_DEL_QUESTION', result: 'Обновление вопроса: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'HRCV_DEL_QUESTION', result: 'Обновление вопроса: ошибка сервера' })
          reject(new Error(err))
        })
    }),
  [HRCV_ADD_ANSWER]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'HRCV_ADD_ANSWER', topic: 'Создание ответа', error: null })
      axios({ url: '/api/anketa/addAnswer.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(HRCV_ADD_ANSWER, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'HRCV_ADD_ANSWER' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'HRCV_ADD_ANSWER', result: 'Создание ответа: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'HRCV_ADD_ANSWER', result: 'Создание ответа: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [HRCV_UPD_ANSWER]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'HRCV_UPD_ANSWER', topic: 'Редактирование ответа', error: null })
      axios({ url: '/api/anketa/addAnswer.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(HRCV_UPD_ANSWER, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'HRCV_UPD_ANSWER' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'HRCV_UPD_ANSWER', result: 'Редактирование ответа: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'HRCV_UPD_ANSWER', result: 'Редактирование ответа: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [HRCV_DEL_ANSWER]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'HRCV_DEL_ANSWER', topic: 'Редактирование ответа', error: null })
      axios({ url: '/api/anketa/delAnswer.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(HRCV_DEL_ANSWER, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'HRCV_DEL_ANSWER' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'HRCV_DEL_ANSWER', result: 'Редактирование ответа: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'HRCV_DEL_ANSWER', result: 'Редактирование ответа: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [HRCV_POST_CV]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'HRCV_POST_CV', topic: 'Изменение состояния запроса', error: null })
      axios({ url: '/api/anketa/postCVState.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(HRCV_POST_CV, params)
            resolve(resp.data)
            dispatch(UI_SUCCESS, { action: 'HRCV_POST_CV' })
          } else {
            dispatch(UI_ERROR, { action: 'HRCV_POST_CV', result: 'Ошибка отправки запроса : ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'HRCV_POST_CV', result: 'Ошибка отправки запроса: ошибка сервера' })
          reject(new Error(err))
        })
    }),
  [HRCV_ADD_VACANCY]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'HRCV_ADD_VACANCY', topic: 'Создание вакансии', error: null })
      axios({ url: '/api/anketa/addVacancy.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(HRCV_ADD_VACANCY, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'HRCV_ADD_VACANCY' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'HRCV_ADD_VACANCY', result: 'Создание вакансии: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'HRCV_ADD_VACANCY', result: 'Создание вакансии: ошибка сервера' })
          reject(new Error(err))
        })
    }),
  [HRCV_UPD_VACANCY]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'HRCV_UPD_VACANCY', topic: 'Изменение вакансии', error: null })
      axios({ url: '/api/anketa/addVacancy.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(HRCV_UPD_VACANCY, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'HRCV_UPD_VACANCY' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'HRCV_UPD_VACANCY', result: 'Изменение вакансии: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'HRCV_UPD_VACANCY', result: 'Изменение вакансии: ошибка сервера' })
          reject(new Error(err))
        })
    }),
  [HRCV_POST_VACANCY]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'HRCV_POST_VACANCY', topic: 'Изменение состояния вакансии', error: null })
      axios({ url: '/api/anketa/postVacancyState.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(HRCV_POST_VACANCY, resp.data.data)
            resolve(resp.data)
            dispatch(UI_SUCCESS, { action: 'HRCV_POST_VACANCY' })
          } else {
            dispatch(UI_ERROR, { action: 'HRCV_POST_VACANCY', result: 'Ошибка отправки запроса : ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'HRCV_POST_VACANCY', result: 'Ошибка отправки запроса: ошибка сервера' })
          reject(new Error(err))
        })
    })
}

const mutations = {

  [HRCV_FREE_DATA]: state => {
    state.currentCV = {}
    state.currentVacancy = {}
    state.currentQuestion = {}
    state.currentAnswer = {}
    state.CVList.splice(0, state.CVList.length)
    state.vacancyList.splice(0, state.vacancyList.length)
    state.CVStatesList.splice(0, state.CVStatesList.length)
    state.vacStatesList.splice(0, state.vacStatesList.length)
    state.CVTypesList.splice(0, state.CVTypesList.length)
    state.CVQuestionsList.splice(0, state.CVQuestionsList.length)
    state.cvListLoading = false
    state.vacListLoading = false
    state.currentCVFilter = null
    state.currentVacancyFilter = null
  },
  [HRCV_GET_CV_STATUS_LIST]: (state, resp) => {
    console.log('HRCV_GET_CV_STATUS_LIST mutation initiated, ', resp)
    state.CVStatesList = resp
  },
  [HRCV_GET_VACANCY_STATES]: (state, resp) => {
    console.log('HRCV_GET_VACANCY_STATES mutation initiated, ', resp)
    state.vacStatesList = resp
  },
  [HRCV_GET_CV_TYPES_LIST]: (state, resp) => {
    console.log('HRCV_GET_CV_TYPES_LIST mutation initiated, ', resp)
    state.CVTypesList = resp
  },
  [HRCV_CLEAR_CV_LIST]: (state) => {
    console.log('HRCV_CLEAR_CV_LIST mutation initiated, ')
    state.CVList.splice(0, state.CVList.length)
  },
  [HRCV_CLEAR_VACANCY_LIST]: (state) => {
    console.log('HRCV_CLEAR_VACANCY_LIST mutation initiated, ')
    state.vacancyList.splice(0, state.vacancyList.length)
  },
  [HRCV_GET_CV_LIST]: (state, resp) => {
    console.log('HRCV_GET_CV_LIST mutation initiated, ', resp)
    state.CVList = resp
  },
  [HRCV_GET_VACANCY_LIST]: (state, resp) => {
    console.log('HRCV_GET_VACANCY_LIST mutation initiated, ', resp)
    state.vacancyList = resp
  },
  [HRCV_SET_CV_FILTER]: (state, resp) => {
    console.log('HRCV_SET_CV_FILTER mutation initiated, ', resp)
    state.currentCVFilter = resp
  },
  [HRCV_SET_VACANCY_FILTER]: (state, resp) => {
    console.log('HRCV_SET_VACANCY_FILTER mutation initiated, ', resp)
    state.currentVacancyFilter = resp
  },
  [HRCV_SET_CV_LOADING_STATE]: (state, resp) => {
    console.log('HRCV_SET_CV_LOADING_STATE mutation initiated, ', resp)
    state.cvListLoading = resp
  },
  [HRCV_SET_VACANCY_LOADING_STATE]: (state, resp) => {
    console.log('HRCV_SET_VACANCY_LOADING_STATE mutation initiated, ', resp)
    state.vacListLoading = resp
  },
  [HRCV_SET_CURRENT_CV]: (state, resp) => {
    console.log('HRCV_SET_CURRENT_CV mutation initiated, ', resp)
    state.currentCV = resp
  },
  [HRCV_SET_CURRENT_VACANCY]: (state, resp) => {
    console.log('HRCV_SET_CURRENT_VACANCY mutation initiated, ', resp)
    state.currentVacancy = resp
  },
  [HRCV_SET_CURRENT_Q]: (state, resp) => {
    console.log('HRCV_SET_CURRENT_Q mutation initiated, ', resp)
    state.currentQuestion = resp
  },
  [HRCV_SET_CURRENT_A]: (state, resp) => {
    console.log('HRCV_SET_CURRENT_A mutation initiated, ', resp)
    // eslint-disable-next-line eqeqeq
    const currAns = state.currentQuestion.ANSWERS.find(item => item.ANS_ID == resp.ANS_ID)
    if (currAns) {
      state.currentAnswer = currAns
    } else {
      state.currentAnswer = {}
    }
  },
  [HRCV_GET_QUESTIONS]: (state, resp) => {
    console.log('HRCV_GET_QUESTIONS mutation initiated, ', resp)
    state.CVQuestionsList = resp
    console.log('HRCV_GET_QUESTIONS mutation finished, ', state.CVQuestionsList)
  },
  [HRCV_GET_ANSWERS]: (state, resp) => {
    console.log('HRCV_GET_ANSWERS mutation initiated, ', resp)
    state.currentQuestion.selectedAnswers = resp
    console.log('HRCV_GET_ANSWERS mutation finished, ', state.currentQuestion.selectedAnswers)
  },
  [HRCV_ADD_QUESTION]: (state, orderItem) => {
    console.log('HRCV_ADD_QUESTION mutation initiated', orderItem)
    state.CVQuestionsList.push(orderItem)
  },
  [HRCV_UPD_QUESTION]: (state, orderItem) => {
    console.log('HRCV_UPD_QUESTION mutation initiated', orderItem)
    const index = state.CVQuestionsList.findIndex(itm => itm.QID === orderItem.QID)
    console.log('Question found - ', index)
    if (index !== -1) {
      state.CVQuestionsList.splice(index, 1, orderItem)
      state.currentQuestion = orderItem
    }
  },
  [HRCV_DEL_QUESTION]: (state, resp) => {
    console.log('HRCV_DEL_QUESTION mutation initiated', resp)
    const index = state.CVQuestionsList.findIndex(itm => itm.QID === resp)
    console.log('Question found - ', index)
    if (index !== -1) {
      state.CVQuestionsListt.splice(index, 1)
      state.currentQuestion = {}
    }
  },
  [HRCV_ADD_ANSWER]: (state, orderItem) => {
    console.log('HRCV_ADD_ANSWER mutation initiated', orderItem)
    state.currentQuestion.ANSWERS.push(orderItem)
  },
  [HRCV_UPD_ANSWER]: (state, orderItem) => {
    console.log('HRCV_UPD_ANSWER mutation initiated', orderItem)
    const index = state.currentQuestion.ANSWERS.findIndex(itm => itm.ANS_ID === orderItem.ANS_ID)
    console.log('Answer found - ', index)
    if (index !== -1) {
      state.currentQuestion.ANSWERS.splice(index, 1, orderItem)
      state.currentAnswer = orderItem
    }
  },
  [HRCV_DEL_ANSWER]: (state, resp) => {
    console.log('HRCV_DEL_ANSWER mutation initiated', resp)
    const index = state.currentQuestion.ANSWERS.findIndex(itm => itm.ANS_ID === resp)
    console.log('Answer found - ', index)
    if (index !== -1) {
      state.currentQuestion.ANSWERS.splice(index, 1)
      state.currentAnswer = {}
    }
  },
  [HRCV_POST_CV]: (state, resp) => {
    console.log('HRCV_POST_CV mutation called. RESP is ', resp)
    var HRCVItem = state.CVList.find(HRCV => HRCV.DOC_ID === resp.DOC_ID)
    if (typeof HRCVItem !== 'undefined') {
      switch (resp.PTC) {
        case 'type':
          HRCVItem.DT_ID = resp.DT_ID
          break
        case 'state':
          HRCVItem.EXEC_DOC_STATUS = resp.EXEC_DOC_STATUS
          break
        case 'time':
          HRCVItem.SCHEDULED_TIME = resp.TIME
          break
        case 'endtest':
          HRCVItem.SCHEDULED_TIME = resp.SHEDULED_TIME
          HRCVItem.EXEC_DOC_STATUS = '1'
          HRCVItem.DS_ID = resp.DS_ID
          break
        default:
          break
      }
    }
  },
  [HRCV_POST_VACANCY]: (state, resp) => {
    console.log('HRCV_POST_VACANCY mutation called. RESP is ', resp)
    state.currentVacancy = resp
  },
  [HRCV_ADD_VACANCY]: (state, resp) => {
    console.log('HRCV_ADD_VACANCY mutation initiated', resp)
    state.vacancyList.push(resp)
  },

  [HRCV_UPD_VACANCY]: (state, resp) => {
    console.log('HRCV_UPD_VACANCY mutation initiated', resp)
    state.currentVacancy = resp
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
